import { accountRoutes } from "app/account/account.routes";
import { authRoutes } from "app/auth/auth.routes";
import { devRoutes } from "app/dev/dev.routes";
import { guestDuplicateRoutes } from "app/guest-duplicate/guest-duplicate.routes";
import { itemRoutes } from "app/items/items.routes";
import { linkRoutes } from "app/link/link.routes";
import { paneRoutes } from "app/panes/panes.routes";
import { sectionRoutes } from "app/sections/sections.routes";
import { teamRoutes } from "app/team/team.routes";
import { termsOfServiceRoutes } from "app/terms-of-service/terms-of-service.routes";
import { activityFeedRoutes } from "app/activity-feed/activity-feed.routes";
import { editRoutes, editSectionRoutes } from "app/edit/edit.routes";
import { notificationsCalendarRoutes } from "app/notifications-calendar/notifications-calendar.routes";
import { chatRoutes } from "app/chat/chat.routes";
import { clockRoutes } from "app/clocks/clocks.routes";
import { homeRoutes } from "app/home/home.routes";
import { routeTitleTranslation } from "i18n/translateHelpers";
import { matchPath } from "react-router-dom";
import { pathnameOf } from "./route";
import type { RouteRender } from "./tree";

/**
 * Every feature's route render list, aggregated, used to resolve a native bar
 * title (and, later, other view options) from a path.
 */
const allRouteRenders: RouteRender[] = [
  ...accountRoutes,
  ...authRoutes,
  ...teamRoutes,
  ...itemRoutes,
  ...linkRoutes,
  ...paneRoutes,
  ...sectionRoutes,
  ...guestDuplicateRoutes,
  ...devRoutes,
  ...clockRoutes,
  ...termsOfServiceRoutes,
  ...activityFeedRoutes,
  ...notificationsCalendarRoutes,
  ...homeRoutes,
  ...chatRoutes,
  ...editRoutes,
  ...editSectionRoutes,
];

/**
 * The native bar title for a path, in the active language. Resolved here rather than at
 * declaration, since route modules are evaluated at import before i18n has initialised.
 * Callers re-invoke on a language change; see NativeLanguageSync.
 */
export function titleForPath(path: string): string | undefined {
  const pathname = pathnameOf(path);
  for (const route of allRouteRenders) {
    if (route.title && matchPath(route.path, pathname)) {
      return typeof route.title === "function" ? route.title() : routeTitleTranslation(route.title);
    }
  }
  return undefined;
}
